'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { LoadingSpinner } from '@/components/LoadingSpinner' // Assuming you have a spinner

export default function NotFound() {
    const router = useRouter()

    useEffect(() => {
        // Redirect to the authenticated home page
        router.replace('/authHome')
    }, [router])

    // Optionally, show a message while redirecting
    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <LoadingSpinner />
            <p className="mt-4 text-muted-foreground">Page not found. Redirecting...</p>
        </div>
    )
}
